import styled from 'styled-components';

export const FooterMessageStyled = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 64px;
  height: 72px;
  width: 100%;

  color: whitesmoke;
  font-size: 20px;
  text-align: center;
  background-color: #3f51b5;
  box-shadow: rgba(0, 0, 0, 0.2) 0px -2px 4px -1px,
    rgba(0, 0, 0, 0.14) 0px -4px 5px 0px, rgba(0, 0, 0, 0.12) 0px -1px 10px 0px;
`;
